<template>
    <section class="gmp-section gmp-mb-l">
        <div class="hero-landing">
            <div class="hero-landing__background hero-landing__overview">
                <div class="gmp-banner gmp-overview-hero">
                    <picture>
                        <img class="gmp-no-grab hero-landing__image" src="@/assets/img/dis.png"
                             alt="Meaningful insights.<br>Smarter marketing.<br>Better results.">
                    </picture>
                </div>
            </div>
            <div class="hero-landing__content">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col--12 h-c-grid__col--align-middle">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                用微信小程序订货
                            </h1>
                            <h2 class="h-c-headline h-c-headline--four">
                                快速响应 更快地处理和响应客户的订单需求，提升客户满意度。
                            </h2>
                            <a href="/" class="h-c-button h-c-button--primary">
                                <div class="gmp-link__content gmp-link__content--cta-btn">
                                    <span>预约上门演示</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "M_heroLanding"
    }
</script>

<style lang="less">


</style>